import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const CompanySetting = loadable(() => import('./General/Edit'), {
  fallback: <FullPageLoader />,
});
